module.exports = __webpack_public_path__ + "static/media/react.74dd1a5b.svg";